import APPCONFIG from '../../constants/Config';
import * as types from '../../constants/ActionTypes';

const initialSettings = APPCONFIG.persist;
const persist = (state = initialSettings, action) => {
  switch (action.type) {
    case types.STORE_PERSISTOR:
      return {
        ...state,
        persistor: action.persistor,
      };
    default:
      return state;
  }
};

export default persist;



// WEBPACK FOOTER //
// ./reducers/app/persist.js